import { AfterViewInit, Component, HostListener, inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTransferComponent, TransferDirection, TransferItem } from 'ng-zorro-antd/transfer';
import { Subject, takeUntil } from 'rxjs';
import { DrawerMode } from 'src/app/core/enums/drawer-mode';
import { UserLoggedService } from 'src/app/core/services/userLogged.service';
import { ScreenService } from 'src/app/public/services/screen.service';
import { MachineDto } from 'src/app/shared/dto/machine.dto';
import { ScreenDto } from 'src/app/shared/dto/screen.dto';
import { UserDto } from 'src/app/shared/dto/user.dto';
import { DirectionsEnum } from 'src/app/shared/enums/directions.enum';
import { ItemFormStructure } from 'src/app/shared/services/form.service';
import { MachineService } from '../../services/machine.service';
import { UserService } from '../../services/user.service';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormModule } from 'ng-zorro-antd/form';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { DRAWER_WIDTH_CHANGE_PLACEMENT } from 'src/app/core/constants/components';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { DefaultComponent } from 'src/app/shared/services/view.service';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
    selector: 'app-screens',
    templateUrl: './screens.component.html',
    styleUrl: './screens.component.scss',
    standalone: true,
    imports: [
        NzPageHeaderModule,
        NzSpaceModule,
        NzDividerModule,
        NzDrawerModule,
        NzDatePickerModule,
        FormsModule,
        NzMessageModule,
        NzTableModule,
        NzSelectModule,
        NzInputDirective,
        ReactiveFormsModule,
        NzFormDirective,
        NzRowDirective,
        NzFormItemComponent,
        NzColDirective,
        NzFormControlComponent,
        NzInputDirective,
        NzFormModule,
        NzTransferComponent,
        NzIconModule,
        NzToolTipModule,
        LoaderComponent,
        NzButtonModule
    ],
})
export class ScreensComponent extends DefaultComponent implements OnInit, AfterViewInit, OnDestroy {

    title: string = '';
    formStructure: ItemFormStructure[] = [];
    componentService: any;

    drawerVisible: boolean = false;
    drawerMode!: DrawerMode;
    drawerTitle: string = '';
    fieldsReadOnly: boolean = false;
    usersSelected: UserDto[] = [];
    machinesTransferItems: TransferItem[] = [];

    screens: ScreenDto[] = [];
    screenSelected!: ScreenDto;
    users: UserDto[] = [];
    userSelected!: UserDto;
    machines: MachineDto[] = [];
    machinesSelectedIds: number[] = [];

    isLoading: boolean = true;
    isSaving: boolean = false;
    userName: string | undefined = '';
    userLogged: { name: string; rol: string; token: string } | null = null;
    currentUser: UserDto = new UserDto();
    
    innerWidth: number = 0;
    DRAWER_WIDTH_CHANGE_PLACEMENT = DRAWER_WIDTH_CHANGE_PLACEMENT;

    validateForm: FormGroup<{
        name: FormControl<string>;
        ip: FormControl<string>;
        users: FormControl<UserDto[]>;
        machines: FormControl<MachineDto[]>;
    }>;

    private readonly userLoggedService = inject(UserLoggedService);
    private readonly screensService = inject(ScreenService);
    private readonly userService = inject(UserService);
    private readonly machineService = inject(MachineService);
    private readonly message = inject(NzMessageService);
    private readonly fb = inject(NonNullableFormBuilder);

    private readonly unsubscribe$ = new Subject<void>();

    constructor() {
        super('screens', '');
        this.validateForm = this.fb.group({
            name: ['', Validators.required],
            ip: ['', [Validators.required, Validators.pattern('(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)')]],
            users: new FormControl<UserDto[]>([], { nonNullable: true }),
            machines: new FormControl<MachineDto[]>([], { nonNullable: true })
        });
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.innerWidth = window.innerWidth;
    }

    async ngOnInit(): Promise<void> {
        this.currentUser = this.userLoggedService.userLogged;
        this.innerWidth = window.innerWidth;

        try {
            this.userName = this.userLoggedService.userLogged?.username;
            this.componentService = this.screensService;

            await this.screensService.setupWebSocket();
            this.screensService.screens$
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                    next: (screens) => {
                        this.screens = screens;
                        this.screenSelected = this.screens.find((screen) => screen.id === this.screenSelected?.id) || new ScreenDto();
                        if (this.screenSelected.id) {
                            this.initTransferItemsComponent();
                        }
                    },
                    error: () => {
                        this.message.error('Error cargando pantallas');
                    }
                });

            await this.userService.setupWebSocket();
            this.userService.users$
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                    next: (users) => {
                        this.users = users;
                        this.usersSelected = this.users.filter((user) => this.usersSelected.some((u) => u.id === user.id));
                    },
                    error: () => {
                        this.message.error('Error cargando usuarios');
                    }

                });

            await this.machineService.setupWebSocket();
            this.machineService.machines$
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(
                    {
                        next: (machines) => {
                            this.machines = machines;
                        },
                        error: () => {
                            this.message.error('Error cargando máquinas');
                        }
                    }
                );
        } catch (err: any) {
            this.message.error(`Error cargando pantallas: ${err.message}`);
        }
        this.isLoading = false;
    }

    ngAfterViewInit() {
        this.innerWidth = window.innerWidth;
    }

    ngOnDestroy(): void {
        this.screensService.disconnectWebSocket();
        this.userService.disconnectWebSocket();
        this.machineService.disconnectWebSocket();
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    openDrawer(): void {
        this.initTransferItemsComponent();
        this.drawerVisible = true;
    }

    closeDrawer(): void {
        this.machinesSelectedIds = [];
        this.machinesTransferItems = [];
        this.screenSelected = new ScreenDto();
        this.validateForm.reset();
        this.drawerVisible = false;
    }

    async submitForm(): Promise<void> {
        this.isSaving = true;
        this.includeSelectedMachinesInForm();

        if (this.validateForm.valid) {
            const screenData: ScreenDto = {
                id: this.screenSelected.id,
                ip: this.validateForm.controls.ip.value ? this.validateForm.controls.ip.value : '',
                name: this.validateForm.controls.name.value ? this.validateForm.controls.name.value : '',
                machines: this.validateForm.controls.machines.value ? this.validateForm.controls.machines.value : [],
                users: this.validateForm.controls.users.value ? this.validateForm.controls.users.value : []
            };

            try {
                if (this.drawerMode === DrawerMode.CREATE) {
                    const screenCreated = await this.screensService.create(screenData);
                    this.isSaving = false;
                    this.message.success(`Pantalla ${screenCreated.name} creada`);
                } else if (this.drawerMode === DrawerMode.EDIT) {
                    const screenEdited = await this.screensService.updateScreen(this.screenSelected.id!, screenData);
                    this.isSaving = false;
                    this.message.success(`Pantalla ${screenEdited.name} editada`);
                }
            } catch (error: any) {
                this.isSaving = false;
                this.message.error(`Error guardando pantalla: ${error.message}`);
            }

            this.closeDrawer();
        } else {
            this.isSaving = false;
            this.message.error('El formulario contiene errores');
        }
    }

    includeSelectedMachinesInForm(): void {
        try {
            this.machinesSelectedIds = [];
            this.machinesTransferItems.forEach((element) => {
                if (element.direction === DirectionsEnum.RIGHT as TransferDirection) {
                    this.machinesSelectedIds.push(element['key']);
                }
            });

            const machinesSelected = this.machines.filter(machine => this.machinesSelectedIds.includes(machine.id));
            this.validateForm.get('machines')?.setValue(machinesSelected);
        } catch (error) {
            this.message.error('Error incluyendo máquinas seleccionadas en el formulario');
        }
    }

    cancelForm(): void {
        this.closeDrawer();
    }

    compareUserFn = (o1: UserDto, o2: UserDto): boolean => {
        return o1 && o2 ? o1.id === o2.id : o1 === o2;
    };

    initTransferItemsComponent(): void {
        try {
            const transferItems: TransferItem[] = [];
            const availableMachines = this.machines.filter((machine) => {
                return !this.screenSelected.machines?.some((m) => m.id === machine.id);
            });

            availableMachines.forEach((availableMachine) => {
                transferItems.push({
                    key: availableMachine.id,
                    title: availableMachine.name,
                    description: availableMachine.ip,
                    direction: DirectionsEnum.LEFT as TransferDirection,
                });
            });

            this.screenSelected.machines?.forEach((assignedMachine) => {
                transferItems.push({
                    key: assignedMachine.id,
                    title: assignedMachine.name,
                    description: assignedMachine.ip,
                    direction: DirectionsEnum.RIGHT as TransferDirection,
                });
            });

            this.machinesTransferItems = transferItems;
        } catch (error) {
            this.message.error('Error inicializando la transferencia de máquinas');
        }
    }

    async create(): Promise<void> {
        this.drawerTitle = 'Crear pantalla';
        this.drawerMode = DrawerMode.CREATE;
        this.fieldsReadOnly = false;
        this.validateForm.enable();
        this.openDrawer();
    }

    view(data: any): void {
        this.drawerTitle = 'Ver pantalla';
        this.drawerMode = DrawerMode.VIEW;
        this.fieldsReadOnly = true;
        this.validateForm.patchValue(data);
        this.validateForm.disable();
        this.screenSelected = data;
        this.openDrawer();
    }

    edit(data: any): void {
        this.drawerTitle = 'Editar pantalla';
        this.drawerMode = DrawerMode.EDIT;
        this.fieldsReadOnly = false;
        this.screenSelected = data;
        this.validateForm.patchValue(data);
        this.validateForm.enable();
        this.openDrawer();
    }

    async delete(data: any): Promise<void> {
        if (window.confirm('¿Estás seguro de que quieres eliminar este artículo? Esta acción no se puede deshacer.')) {
            try {
                const screenDeleted = await this.screensService.deleteScreen(data.id);
                this.message.success(`Pantalla ${screenDeleted.name} eliminada`);
            } catch (error) {
                this.message.error('Error eliminando pantalla');
            }
        }
    }
}
